export const getCheckAvailabilityCallbackStudent = (): (() => boolean) => {
  return () => false
}
